import Ajax from '../ajax';

export default {
  list: (filter) => Ajax('get', 'shoppingGiveBackRequest', filter),
  export: (filter) => Ajax('get', 'shoppingGiveBackRequest/export', filter),
};
